import state from './state';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import { Module } from 'vuex';
import { VersionsStateShape, RootStateShape } from 'store';

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
} as Module<VersionsStateShape, RootStateShape>;
